import React, { useState } from 'react';
import { theme } from '../theme';

const MonthPicker = ({ label, value = '', onChange, minYear, maxYear, showMonth = true }) => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = String(now.getMonth() + 1).padStart(2, '0');
    const [focused, setFocused] = useState(false);

    const [year, month] = value && value.includes('-') ? value.split('-') : ['', ''];

    const fromYear = minYear ?? currentYear - 5;
    const toYear = maxYear ?? currentYear + 1;
    const years = [];
    for (let y = fromYear; y <= toYear; y++) years.push(y);
    const months = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));

    const handleYearChange = (e) => {
        const y = e.target.value;
        if (!y) { onChange(''); return; }
        onChange(`${y}-${month || currentMonth}`);
    };

    const handleMonthChange = (e) => {
        const m = e.target.value;
        if (!m) { onChange(''); return; }
        onChange(`${year || currentYear}-${m}`);
    };

    const selectStyle = {
        background: 'transparent',
        border: 'none',
        borderBottom: `2px solid ${focused ? theme.primary : theme.borderStrong}`,
        borderRadius: 0,
        color: 'var(--ink-text)',
        padding: '6px 2px',
        fontWeight: 600,
        fontSize: '1rem',
        outline: 'none',
        cursor: 'pointer',
        width: '100%',
        transition: 'border-color 0.2s',
    };

    return (
        <div>
            {label && (
                <label className="mb-1 d-block text-white small text-uppercase fw-bold opacity-75">{label}</label>
            )}
            <div className="d-flex align-items-end gap-2">
                <select
                    value={year}
                    onChange={handleYearChange}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    style={{ ...selectStyle, flex: 2 }}
                >
                    <option value="" style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>Año</option>
                    {years.map(y => (
                        <option key={y} value={y} style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>{y}</option>
                    ))}
                </select>
                {showMonth && (
                    <>
                        <span style={{ color: 'var(--ink-text-dim)', paddingBottom: '6px' }}>/</span>
                        <select
                            value={month}
                            onChange={handleMonthChange}
                            onFocus={() => setFocused(true)}
                            onBlur={() => setFocused(false)}
                            style={{ ...selectStyle, flex: 1 }}
                        >
                            <option value="" style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>Mes</option>
                            {months.map(m => (
                                <option key={m} value={m} style={{ background: 'var(--ink-surface-2)', color: 'var(--ink-text)' }}>{m}</option>
                            ))}
                        </select>
                    </>
                )}
            </div>
        </div>
    );
};

export default MonthPicker;
